/* eslint-disable max-lines-per-function */
import { ApproveDocumentationUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ApproveEstimateUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ApproveSolicitationUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ApproveUcValidationUseCase } from '@/data/use-cases/developments-use-cases.js';
import { AssignTechLeadUseCase } from '@/data/use-cases/developments-use-cases.js';
import { CancelDevelopmentUseCase } from '@/data/use-cases/developments-use-cases.js';
import { CloseWithoutUcUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ConfirmNoJiraPairUseCase } from '@/data/use-cases/developments-use-cases.js';
import { CreateDevelopmentUseCase } from '@/data/use-cases/developments-use-cases.js';
import { CreateEstimateUseCase } from '@/data/use-cases/developments-use-cases.js';
import { CreateSolicitationUseCase } from '@/data/use-cases/developments-use-cases.js';
import { DeleteDevelopmentUseCase } from '@/data/use-cases/developments-use-cases.js';
import { DeleteEfUseCase } from '@/data/use-cases/developments-use-cases.js';
import { DownloadCfEvidenceUseCase } from '@/data/use-cases/developments-use-cases.js';
import { DownloadDocumentUseCase } from '@/data/use-cases/developments-use-cases.js';
import { DownloadEfUseCase } from '@/data/use-cases/developments-use-cases.js';
import { DownloadUcEvidenceUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ExportDevelopmentsExcelUseCase } from '@/data/use-cases/developments-use-cases.js';
import { GetAiAnalysisProgressUseCase } from '@/data/use-cases/developments-use-cases.js';
import { GetPbiDecompositionUseCase } from '@/data/use-cases/developments-use-cases.js';
import { GetSolicitationEvidenceDownloadUrlUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ImpedeDevelopmentUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ImportDevelopmentsExcelUseCase } from '@/data/use-cases/developments-use-cases.js';
import { LinkJiraEpicUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ListCfEvidencesUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ListJiraEpicsUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ListProjectJiraEpicsUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ListSolicitationEvidencesUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ListUcEvidencesUseCase } from '@/data/use-cases/developments-use-cases.js';
import { LoadAuditUseCase } from '@/data/use-cases/developments-use-cases.js';
import { LoadDevelopmentByIdUseCase } from '@/data/use-cases/developments-use-cases.js';
import { LoadDevelopmentsUseCase } from '@/data/use-cases/developments-use-cases.js';
import { MakeDeveloperLeadUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ReactivateDevelopmentUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ReclassifySolicitationUseCase } from '@/data/use-cases/developments-use-cases.js';
import { RegisterDevEndUseCase } from '@/data/use-cases/developments-use-cases.js';
import { RejectDocumentationUseCase } from '@/data/use-cases/developments-use-cases.js';
import { RejectEstimateUseCase } from '@/data/use-cases/developments-use-cases.js';
import { RejectSolicitationUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ReleaseToUcUseCase } from '@/data/use-cases/developments-use-cases.js';
import { RemoveDeveloperUseCase } from '@/data/use-cases/developments-use-cases.js';
import { RemoveSolicitationEvidenceUseCase } from '@/data/use-cases/developments-use-cases.js';
import { RemoveValidationEvidenceUseCase } from '@/data/use-cases/developments-use-cases.js';
import { RequestAiAnalysisUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ResolveSolicitationUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ResumeDevelopmentUseCase } from '@/data/use-cases/developments-use-cases.js';
import { RetryJiraSyncUseCase } from '@/data/use-cases/developments-use-cases.js';
import { RetryPbiDecompositionUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ReturnEstimateToAnalysisUseCase } from '@/data/use-cases/developments-use-cases.js';
import { SendToDevelopmentUseCase } from '@/data/use-cases/developments-use-cases.js';
import { SetDevelopersUseCase } from '@/data/use-cases/developments-use-cases.js';
import { StartDevelopmentUseCase } from '@/data/use-cases/developments-use-cases.js';
import { SubmitEstimateUseCase } from '@/data/use-cases/developments-use-cases.js';
import { ToggleCutoverNotRequiredUseCase } from '@/data/use-cases/developments-use-cases.js';
import { UnlinkJiraEpicUseCase } from '@/data/use-cases/developments-use-cases.js';
import { UpdateDevelopmentUseCase } from '@/data/use-cases/developments-use-cases.js';
import { UploadDocumentUseCase } from '@/data/use-cases/developments-use-cases.js';
import { UploadEfUseCase } from '@/data/use-cases/developments-use-cases.js';
import { UploadSolicitationEvidenceUseCase } from '@/data/use-cases/developments-use-cases.js';
import { UploadValidationEvidenceUseCase } from '@/data/use-cases/developments-use-cases.js';
import type { FetchHttpClient } from '@/infra/http/fetch-http-client.js';
import { DevelopmentRepositoryImpl } from '@/infra/repositories/development-repository-impl.js';
import { DevelopmentController } from '@/presentation/controllers/development-controller.js';
import { DevelopmentDetailController } from '@/presentation/controllers/development-detail-controller.js';

export const makeDevelopmentController = (httpClient: FetchHttpClient): DevelopmentController => {
    const repository = new DevelopmentRepositoryImpl(httpClient);
    return new DevelopmentController(
        new LoadDevelopmentsUseCase(repository),
        new LoadDevelopmentByIdUseCase(repository),
        new CreateDevelopmentUseCase(repository),
        new UpdateDevelopmentUseCase(repository),
        new CancelDevelopmentUseCase(repository),
        new ReactivateDevelopmentUseCase(repository),
        new ImpedeDevelopmentUseCase(repository),
        new ResumeDevelopmentUseCase(repository),
        new DeleteDevelopmentUseCase(repository),
        new StartDevelopmentUseCase(repository),
        new ExportDevelopmentsExcelUseCase(repository),
        new ImportDevelopmentsExcelUseCase(repository),
        new ListProjectJiraEpicsUseCase(repository)
    );
};

export const makeDevelopmentDetailController = (httpClient: FetchHttpClient): DevelopmentDetailController => {
    const repository = new DevelopmentRepositoryImpl(httpClient);
    return new DevelopmentDetailController(
        new UploadEfUseCase(repository),
        new DeleteEfUseCase(repository),
        new DownloadEfUseCase(repository),
        new RequestAiAnalysisUseCase(repository),
        new SendToDevelopmentUseCase(repository),
        new CreateEstimateUseCase(repository),
        new ApproveEstimateUseCase(repository),
        new RejectEstimateUseCase(repository),
        new SubmitEstimateUseCase(repository),
        new ReturnEstimateToAnalysisUseCase(repository),
        new AssignTechLeadUseCase(repository),
        new SetDevelopersUseCase(repository),
        new RemoveDeveloperUseCase(repository),
        new MakeDeveloperLeadUseCase(repository),
        new UploadDocumentUseCase(repository),
        new DownloadDocumentUseCase(repository),
        new RegisterDevEndUseCase(repository),
        new ToggleCutoverNotRequiredUseCase(repository),
        new ApproveDocumentationUseCase(repository),
        new RejectDocumentationUseCase(repository),
        new UploadValidationEvidenceUseCase(repository),
        new ListCfEvidencesUseCase(repository),
        new ListUcEvidencesUseCase(repository),
        new RemoveValidationEvidenceUseCase(repository),
        new DownloadCfEvidenceUseCase(repository),
        new DownloadUcEvidenceUseCase(repository),
        new ReleaseToUcUseCase(repository),
        new ApproveUcValidationUseCase(repository),
        new CloseWithoutUcUseCase(repository),
        new CreateSolicitationUseCase(repository),
        new ApproveSolicitationUseCase(repository),
        new RejectSolicitationUseCase(repository),
        new ResolveSolicitationUseCase(repository),
        new ReclassifySolicitationUseCase(repository),
        new ListSolicitationEvidencesUseCase(repository),
        new UploadSolicitationEvidenceUseCase(repository),
        new RemoveSolicitationEvidenceUseCase(repository),
        new GetSolicitationEvidenceDownloadUrlUseCase(repository),
        new LoadAuditUseCase(repository),
        new GetPbiDecompositionUseCase(repository),
        new GetAiAnalysisProgressUseCase(repository),
        new RetryPbiDecompositionUseCase(repository),
        new ListJiraEpicsUseCase(repository),
        new LinkJiraEpicUseCase(repository),
        new ConfirmNoJiraPairUseCase(repository),
        new RetryJiraSyncUseCase(repository),
        new UnlinkJiraEpicUseCase(repository)
    );
};
